export const availableCountries = [
    { isoCode: 'BE', name: 'België' },
    { isoCode: 'BG', name: 'Bulgarije' },
    { isoCode: 'CY', name: 'Cyprus' },
    { isoCode: 'DK', name: 'Denemarken' },
    { isoCode: 'DE', name: 'Duitsland' },
    { isoCode: 'EE', name: 'Estland' },
    { isoCode: 'FI', name: 'Finland' },
    { isoCode: 'FR', name: 'Frankrijk' },
    { isoCode: 'GR', name: 'Griekenland' },
    { isoCode: 'HU', name: 'Hongarije' },
    { isoCode: 'IE', name: 'Ierland' },
    { isoCode: 'IT', name: 'Italië' },
    { isoCode: 'HR', name: 'Kroatië' },
    { isoCode: 'LV', name: 'Letland' },
    { isoCode: 'LT', name: 'Litouwen' },
    { isoCode: 'LU', name: 'Luxemburg' },
    { isoCode: 'MT', name: 'Malta' },
    { isoCode: 'NL', name: 'Nederland' },
    { isoCode: 'AT', name: 'Oostenrijk' },
    { isoCode: 'PL', name: 'Polen' },
    { isoCode: 'PT', name: 'Portugal' },
    { isoCode: 'RO', name: 'Roemenië' },
    { isoCode: 'SI', name: 'Slovenië' },
    { isoCode: 'SK', name: 'Slowakije' },
    { isoCode: 'ES', name: 'Spanje' },
    { isoCode: 'CZ', name: 'Tsjechië' },
    { isoCode: 'GB', name: 'Verenigd Koninkrijk' },    
    { isoCode: 'SE', name: 'Zweden' }
]as const;

export const getIsoCodeByName = (name: string): string => {
    const country = availableCountries.find(country => country.name === name);
    return country?.isoCode ?? '';
};

export const getNameByIsoCode = (isoCode: string): string => {
    const country = availableCountries.find(country => country.isoCode === isoCode);
    return country?.name ?? '';
};


